export default "/img/v12-0-0_fig4.286e2172a02d03c44c9633e287b9804f.png";